import React from "react";
import { joinClass } from "./joinClass";

/**
 * Корневой контейнер CC-V4: scope для всех v4-стилей (`company-card-v4`).
 * Документация и примеры: dmc-ui Storybook → CC-V4 / CcV4Root.
 *
 * @param {boolean} [withMainPage=false] — класс `main-page`
 * @param {string} [pageVariant] — модификатор страницы (`company-list-page-v4`, …)
 */
export function CcV4Root({
  children,
  className,
  pageVariant,
  withMainPage = false,
  as = "div",
  ...rest
}) {
  const Component = as;
  return (
    <Component
      className={joinClass(
        withMainPage && "main-page",
        "company-card-v4",
        pageVariant,
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}
